import { DOMRouteHandler } from './DOMRouteHandler';
import { initPreactivationUpgradeInput } from '../modules/preactivationUpgrade';
import initUpgradablePetsModule from '../modules/upgradeablePets';

export class TemplateProductUpg extends DOMRouteHandler {
  static async initAsync(): Promise<void> {
    initPreactivationUpgradeInput();
    await initUpgradablePetsModule();
  }
}
